import { createContext, useMemo } from "react";
import PropTypes from "prop-types";

export const LocalizationContext = createContext({
  language: "",
  translations: {},
});

export const LocalizationContextProvider = ({ language, translations, children }) => {
  const localizationContextProviderValue = useMemo(() => ({
    language,
    translations,
  }), [language, translations]);

  return <LocalizationContext.Provider
    value={localizationContextProviderValue}
  >
    {children}
  </LocalizationContext.Provider>
};

LocalizationContextProvider.propTypes = {
  language: PropTypes.string,
  translations: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

LocalizationContextProvider.defaultProps = {
  language: "en",
  translations: {},
};
